export const theme = {
  color: {
    accent_hex: "#e04556",
    accent_rgba: "224, 69, 86, 0.5",
  },
};
